import * as React from "react";
import type { SVGProps } from "react";

/**
 * The filled information mark, matching the one the dashboard uses for the
 * same job elsewhere on a screen.
 *
 * 18 to match the shrunk input label it sits beside, which the theme sets to
 * 18px. Callers standing it against smaller type should say so.
 *
 * Takes a ref: a tooltip hands one to whatever it wraps, and silently keeps
 * its hover listeners if the child cannot hold it.
 */
export const InformationCircleIcon = React.forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>((props, ref) => (
  <svg ref={ref} viewBox="0 0 24 24" width={18} height={18} {...props}>
    <path
      d="M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0Zm0.25 5a1.5 1.5 0 1 1 -1.5 1.5 1.5 1.5 0 0 1 1.5 -1.5Zm2.25 13.5h-4a1 1 0 0 1 0 -2h0.75a0.25 0.25 0 0 0 0.25 -0.25v-4.5a0.25 0.25 0 0 0 -0.25 -0.25h-0.75a1 1 0 0 1 0 -2h1a2 2 0 0 1 2 2v4.75a0.25 0.25 0 0 0 0.25 0.25h0.75a1 1 0 0 1 0 2Z"
      fill="currentColor"
    />
  </svg>
));

InformationCircleIcon.displayName = "InformationCircleIcon";
